// Scroll reveal for the home page: doors, service rows, How It Works. Loaded through
// snippets/consumer-company-reveal, which only prints this script when Origin's
// animations_reveal_on_scroll setting is on, so both obey one switch.
// The choreography itself stays bespoke: consumer-company-services.css moves the row
// body before its image, which Origin's single offscreen class cannot express.
(function () {
  // Every section that reveals renders the snippet; run once.
  if (window.valCompanyReveal) return;
  window.valCompanyReveal = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('val-motion');

  const REVEAL_SELECTOR = '.val-doors__door, .val-services__row, .val-how__invite, .val-how__steps';

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: 0.04
    }
  );

  const reveal = function (root) {
    root.querySelectorAll(REVEAL_SELECTOR).forEach(function (node) {
      if (node.hasAttribute('data-reveal')) return;
      node.setAttribute('data-reveal', '');
      node.classList.add('val-reveal');
      observer.observe(node);
    });
  };

  reveal(document);

  // Theme editor re-renders a section as fresh nodes; without this they never reveal.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      reveal(event.target);
    });
  }
})();
